/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * Simulate a click event.
 * @public
 * @param {Element} elem  the element to simulate a click on
 */
var simulateClick = function (elem) {
	// Create our event (with options)
	var evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window
	});
	// If cancelled, don't dispatch our event
	var canceled = !elem.dispatchEvent(evt);
};

// var elem = document.querySelector('.Drawer__Close');
// simulateClick(elem);

document.addEventListener('click', function (event) {

	// If the clicked element doesn't have the right selector, bail
	if (!event.target.matches('.click-to-enter')) return;

	// Don't follow the link
	event.preventDefault();

	// Log the clicked element in the console
	console.log(event.target);
  
    var elem = document.querySelector('.fullscreen-vid-mobile');
    elem.style.display = 'none';

}, false);

document.addEventListener('click', function (event) {

	// If the clicked element doesn't have the right selector, bail
	if (!event.target.matches('.click-to-enter')) return;

	// Don't follow the link
	event.preventDefault();

	// Log the clicked element in the console
	console.log(event.target);
  
    var elem = document.querySelector('.fullscreen-vid-desktop');
    elem.style.display = 'none';

}, false);

jQuery(document).ready(function($){
  
  $('a[href="/search"]').click(function(){
    $('.Drawer__Close').trigger('click');
  });
  
  if(window.location.hash) {
    // Fragment exists
    console.log('here !!!');
  } else {
    // Fragment doesn't exist
    $('.fullscreen-vid').addClass('active');
  }
  
});

/* ============================================================
   LOA collection toolbar: filters (AJAX via Section Rendering
   API), view switcher, panel toggle. Lives here (not inline in
   the section) so it also works in the theme editor, where
   injected section scripts never execute. All handlers are
   delegated and discover their section at interaction time.
   ============================================================ */
(function () {
  if (window.__loaFilterAjax) return;
  window.__loaFilterAjax = true;

  var sectionFor = function (el) {
    return el.closest('[data-section-type="featured-collections"]');
  };

  var anySection = function () {
    var panel = document.querySelector('[data-loa-filter-panel]');
    return panel ? sectionFor(panel) : document.querySelector('[data-section-type="featured-collections"]');
  };

  var buildUrl = function (panel) {
    var params = new URLSearchParams();
    panel.querySelectorAll('input:checked').forEach(function (input) {
      if (input.name) params.append(input.name, input.value);
    });
    var base = panel.getAttribute('action') || window.location.pathname;
    var qs = params.toString();
    return base + (qs ? '?' + qs : '');
  };

  var applying = false;

  var apply = function (panel, url, push) {
    if (applying) return;

    var root = sectionFor(panel);
    if (!root || root.querySelector('.ProductList--carousel')) {
      window.location = url;
      return;
    }

    var sectionId = root.getAttribute('data-section-id');
    applying = true;
    root.style.opacity = '0.45';
    root.style.transition = 'opacity 0.2s ease';

    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId)
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshRoot = doc.querySelector('[data-section-id="' + sectionId + '"]') || doc.body;

        var oldPanel = root.querySelector('[data-loa-filter-panel]');
        var newPanel = freshRoot.querySelector('[data-loa-filter-panel]');
        if (oldPanel && newPanel) {
          newPanel.classList.add('is-open');
          newPanel.style.transition = 'none';
          oldPanel.replaceWith(newPanel);
          requestAnimationFrame(function () { newPanel.style.transition = ''; });
        }

        var oldGrids = root.querySelectorAll('.ProductListWrapper');
        var newGrids = freshRoot.querySelectorAll('.ProductListWrapper');
        oldGrids.forEach(function (g, i) {
          if (newGrids[i]) g.replaceWith(newGrids[i]);
        });

        /* Hydrate lazy images (lazySizes is bundled inside theme.min.js,
           not exposed on window, and won't see swapped-in nodes) */
        root.querySelectorAll('img.Image--lazyLoad').forEach(function (img) {
          var src = img.getAttribute('data-src');
          if (!src) return;

          if (window.lazySizes && window.lazySizes.loader) {
            window.lazySizes.loader.unveil(img);
            return;
          }

          var widths = [];
          try { widths = JSON.parse(img.getAttribute('data-widths') || '[]'); } catch (err) {}

          if (widths.length) {
            img.setAttribute('srcset', widths.map(function (w) {
              return src.replace('{width}', w) + ' ' + w + 'w';
            }).join(', '));
            var holder = img.closest('.AspectRatio') || img.parentElement;
            var w = holder ? Math.round(holder.getBoundingClientRect().width) : 0;
            img.setAttribute('sizes', (w || 800) + 'px');
          }

          img.src = src.replace('{width}', '800');
          img.classList.add('lazyloaded');
          img.classList.remove('Image--lazyLoad');
        });

        /* Element-staggering hides .ProductItem until a page-load observer
           reveals it — reveal swapped-in items with a matching stagger */
        var items = root.querySelectorAll('.ProductList .ProductItem');
        items.forEach(function (el, idx) {
          var delay = Math.min(idx * 0.06, 0.6);
          el.style.visibility = 'visible';
          el.style.opacity = '0';
          el.style.transform = 'translateY(20px)';
          el.style.transition = 'opacity 0.35s ease ' + delay + 's, transform 0.35s ease ' + delay + 's';
        });
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            items.forEach(function (el) {
              el.style.opacity = '1';
              el.style.transform = 'translateY(0)';
            });
          });
        });

        window.dispatchEvent(new Event('resize'));

        if (push) history.pushState({ loaFilter: true }, '', url);
        root.style.opacity = '';
        applying = false;
      })
      .catch(function () {
        window.location = url;
      });
  };

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-loa-filters-toggle]');
    if (!toggle) return;
    var root = sectionFor(toggle) || document;
    var panel = root.querySelector('[data-loa-filter-panel]');
    if (panel) panel.classList.toggle('is-open');
  });

  var setView = function (view, from) {
    var root = (from && sectionFor(from)) || anySection();
    if (!root) return;
    root.classList.remove('loa-view-2', 'loa-view-3');
    if (view === '2') root.classList.add('loa-view-2');
    if (view === '3') root.classList.add('loa-view-3');
    document.querySelectorAll('[data-loa-view]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-loa-view') === view);
    });
    try { localStorage.setItem('loa-collection-view', view); } catch (err) {}
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-loa-view]');
    if (btn) setView(btn.getAttribute('data-loa-view'), btn);

    var chToggle = e.target.closest('[data-loa-chapter-toggle]');
    if (chToggle) {
      var ch = chToggle.closest('[data-loa-chapter]');
      if (ch) ch.classList.toggle('is-expanded');
    }

    var cycle = e.target.closest('[data-loa-view-cycle]');
    if (cycle) {
      var current = '1';
      try { current = localStorage.getItem('loa-collection-view') || '1'; } catch (err) {}
      var next = current === '1' ? '2' : current === '2' ? '3' : '1';
      setView(next, cycle);
    }
  });

  /* Panels on pages whose context has no filters hydrate themselves from a
     real collection URL via the Section Rendering API */
  var hydratePanel = function () {
    var panel = document.querySelector('[data-loa-filter-panel][data-loa-needs-remote]');
    if (!panel || panel.__loaHydrating) return;
    var root = sectionFor(panel);
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var url = panel.getAttribute('data-loa-needs-remote');
    panel.__loaHydrating = true;

    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId)
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-loa-filter-panel]');
        if (!fresh) return;
        fresh.removeAttribute('data-loa-needs-remote');
        if (panel.classList.contains('is-open')) {
          fresh.classList.add('is-open');
          fresh.style.transition = 'none';
        }
        panel.replaceWith(fresh);
        requestAnimationFrame(function () { fresh.style.transition = ''; });
      })
      .catch(function () {
        panel.__loaHydrating = false;
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydratePanel);
  } else {
    hydratePanel();
  }
  document.addEventListener('shopify:section:load', function () {
    setTimeout(hydratePanel, 100);
  });

  var restoreView = function () {
    try {
      var savedView = localStorage.getItem('loa-collection-view');
      if (savedView && savedView !== '1') setView(savedView);
    } catch (err) {}
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreView);
  } else {
    restoreView();
  }

  /* Theme editor: re-apply the view when the section re-renders */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(restoreView, 50);
  });

  document.addEventListener('change', function (e) {
    var panel = e.target.closest('[data-loa-filter-panel]');
    if (!panel) return;
    if (e.target.type !== 'checkbox' && e.target.type !== 'radio') return;
    apply(panel, buildUrl(panel), true);
  });

  window.addEventListener('popstate', function () {
    var panel = document.querySelector('[data-loa-filter-panel]');
    if (panel) apply(panel, window.location.pathname + window.location.search, false);
  });
})();


/* LOA cart drawer: quick-add from the SUGGESTED rail. Prestige's MiniCart
   listens for product:added and re-renders/opens the drawer. */
(function () {
  if (window.__loaCartQuickAdd) return;
  window.__loaCartQuickAdd = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-loa-quick-add]');
    if (!btn) return;
    if (btn.__loaAdding) return;
    btn.__loaAdding = true;
    btn.style.opacity = '0.4';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-loa-quick-add'), 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        btn.__loaAdding = false;
        btn.style.opacity = '';
      });
  });
})();

/* LOA cart drawer: in-line size switching. Swaps the cart line to the chosen
   variant (add the new variant, then remove the old line by its original index)
   and refreshes the mini-cart via Prestige's documented cart:refresh hook. */
(function () {
  if (window.__loaCartSizeSwitch) return;
  window.__loaCartSizeSwitch = true;

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-loa-size-switch]');
    if (!sel) return;

    var newId = parseInt(sel.value, 10);
    var line = parseInt(sel.getAttribute('data-line'), 10);
    var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    if (!newId || !line) return;
    if (sel.__loaSwitching) return;
    sel.__loaSwitching = true;
    sel.disabled = true;
    sel.style.opacity = '0.4';

    // Add the new variant first (appends or merges, leaving the old line index
    // stable), then remove the old line, then re-render the drawer.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: newId, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        sel.__loaSwitching = false;
        sel.disabled = false;
        sel.style.opacity = '';
      });
  });
})();


/* LOA cart drawer: CHOOSE SIZE panel. When a multi-size product's "+" is tapped
   in the SUGGESTED rail, a panel slides over the cart (like the cart drawer),
   lists sizes with availability, and adds the chosen variant on confirm. */
(function () {
  if (window.__loaSizeDrawer) return;
  window.__loaSizeDrawer = true;

  var drawer, listEl, addBtn, priceEl, selected = { id: null };

  function build() {
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.id = 'loa-size-drawer';
    drawer.className = 'LoaSizeDrawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<div class="LoaSizeDrawer__Overlay" data-loa-size-close></div>' +
      '<div class="LoaSizeDrawer__Panel" role="dialog" aria-label="Choose size">' +
        '<div class="LoaSizeDrawer__Head">' +
          '<span class="LoaSizeDrawer__Title">Choose Size</span>' +
          '<button type="button" class="LoaSizeDrawer__Close" data-loa-size-close aria-label="Close">' +
            '<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M2 2 L14 14 M14 2 L2 14" stroke="currentColor" stroke-width="1.2"/></svg>' +
          '</button>' +
        '</div>' +
        '<ul class="LoaSizeDrawer__List"></ul>' +
        '<div class="LoaSizeDrawer__Footer">' +
          '<button type="button" class="LoaSizeDrawer__Add" disabled>' +
            '<span class="LoaSizeDrawer__AddLabel">Add to cart</span>' +
            '<span class="LoaSizeDrawer__AddPrice"></span>' +
          '</button>' +
        '</div>' +
      '</div>';
    // teleport to body so Prestige's page-level transforms don't break fixed positioning
    document.body.appendChild(drawer);
    listEl = drawer.querySelector('.LoaSizeDrawer__List');
    addBtn = drawer.querySelector('.LoaSizeDrawer__Add');
    priceEl = drawer.querySelector('.LoaSizeDrawer__AddPrice');
    return drawer;
  }

  function open() { build(); void drawer.getBoundingClientRect(); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
  function close() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); } }

  function esc(str) { return String(str == null ? '' : str).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function populate(data) {
    build();
    listEl.innerHTML = '';
    selected = { id: null };
    addBtn.disabled = true;
    priceEl.textContent = '';
    (data.sizes || []).forEach(function (s) {
      var li = document.createElement('li');
      li.className = 'LoaSizeDrawer__Size';
      var blocked = !s.available || !s.id;
      var note = blocked ? 'This size is not available right now.' : (s.low ? 'Last pieces available' : '');
      if (blocked) li.classList.add('is-unavailable');
      li.innerHTML = '<span class="LoaSizeDrawer__SizeLabel">' + esc(s.label) + '</span>' +
                     '<span class="LoaSizeDrawer__SizeNote">' + esc(note) + '</span>';
      if (!blocked) {
        li.addEventListener('click', function () {
          var rows = listEl.querySelectorAll('.LoaSizeDrawer__Size');
          for (var i = 0; i < rows.length; i++) rows[i].classList.remove('is-selected');
          li.classList.add('is-selected');
          selected = { id: s.id, price: s.price };
          addBtn.disabled = false;
          priceEl.textContent = s.price || '';
        });
      }
      listEl.appendChild(li);
    });
  }

  // Open on "+" for a multi-size suggestion
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-loa-choose-size]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.LoaCartSuggested__Card');
    var script = card && card.querySelector('.LoaSizeData');
    if (!script) return;
    var data;
    try { data = JSON.parse(script.textContent); } catch (err) { return; }
    populate(data);
    open();
  });

  // Close (X, overlay, Escape)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-loa-size-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
  });

  // Add the chosen size, then refresh the cart drawer
  document.addEventListener('click', function (e) {
    var add = e.target.closest('.LoaSizeDrawer__Add');
    if (!add || add.disabled || !selected.id) return;
    if (add.__loaAdding) return;
    add.__loaAdding = true;
    add.style.opacity = '0.5';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: selected.id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        add.__loaAdding = false;
        add.style.opacity = '';
        close();
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { add.__loaAdding = false; add.style.opacity = ''; });
  });
})();


/* =============================================================================
   LOA BACKGROUND AUDIO PLAYER — Global Controller
   Uses the official YouTube IFrame Player API (YT.Player) so we get a real
   JS object with .unMute() / .setVolume() in onReady — no postMessage guessing.
   ============================================================================= */

(function() {
  'use strict';

  var STORAGE_KEY = 'loa_bg_track';

  var playerEl  = null;   // the #loa-bg-player DOM node
  var titleEl   = null;
  var toggleBtn = null;
  var closeBtn  = null;
  var iconPause = null;
  var iconPlay  = null;
  var isPaused  = false;
  var ytPlayer  = null;   // YT.Player instance
  var pendingTrack = null; // track waiting for YT API to be ready

  function isSoundPage() {
    return !!document.querySelector('.loa-sound');
  }

  function getElapsed(startedAt) {
    return Math.max(0, Math.floor((Date.now() - startedAt) / 1000));
  }

  function setPlayingState() {
    isPaused = false;
    if (playerEl) playerEl.classList.remove('is-paused');
    if (playerEl) playerEl.classList.remove('is-waiting');
    if (toggleBtn) toggleBtn.setAttribute('aria-label', 'Pause');
    if (iconPause) iconPause.style.display = '';
    if (iconPlay)  iconPlay.style.display  = 'none';
    if (titleEl) titleEl.removeAttribute('data-waiting');
  }

  function setPausedState() {
    isPaused = true;
    if (playerEl) playerEl.classList.add('is-paused');
    if (toggleBtn) toggleBtn.setAttribute('aria-label', 'Play');
    if (iconPause) iconPause.style.display = 'none';
    if (iconPlay)  iconPlay.style.display  = '';
  }

  // Called once YT.Player fires onReady
  function onPlayerReady(event) {
    // Video is playing muted via autoplay — now wait for first user gesture
    // to unmute. This is the only reliable cross-browser approach.
    waitForGestureToUnmute(event.target);
  }

  // Shows a subtle "tap to hear" hint, then unmutes on first interaction
  function waitForGestureToUnmute(ytInstance) {
    if (playerEl) playerEl.classList.add('is-waiting');
    if (titleEl) titleEl.setAttribute('data-waiting', '1');

    var events = ['click', 'touchstart', 'keydown', 'scroll', 'mousemove'];
    var triggered = false;

    function onGesture() {
      if (triggered) return;
      triggered = true;

      // Remove all listeners
      events.forEach(function(ev) {
        document.removeEventListener(ev, onGesture, true);
      });

      // User has interacted — unmute and ensure video is playing
      ytInstance.unMute();
      ytInstance.setVolume(100);
      // If autoplay was blocked the video may be paused — force play
      if (typeof ytInstance.getPlayerState === 'function') {
        var state = ytInstance.getPlayerState();
        // -1 = unstarted, 2 = paused, 5 = cued
        if (state === -1 || state === 2 || state === 5) {
          ytInstance.playVideo();
        }
      }
      setPlayingState();
    }

    events.forEach(function(ev) {
      document.addEventListener(ev, onGesture, { capture: true, passive: true, once: true });
    });
  }

  function createOrUpdateYT(track) {
    var elapsed = getElapsed(track.startedAt || Date.now());

    if (ytPlayer && typeof ytPlayer.loadVideoById === 'function') {
      ytPlayer.loadVideoById({ videoId: track.ytId, startSeconds: elapsed });
      // loadVideoById resets mute state — wait for gesture again
      setTimeout(function() {
        waitForGestureToUnmute(ytPlayer);
      }, 800);
    } else {
      ytPlayer = new YT.Player('loa-bg-iframe', {
        videoId: track.ytId,
        playerVars: {
          autoplay:       1,
          mute:           1,
          start:          elapsed,
          controls:       0,
          rel:            0,
          modestbranding: 1,
          playsinline:    1
        },
        events: {
          onReady:       onPlayerReady,
          onStateChange: function(e) {
            if (e.data === YT.PlayerState.ENDED) stopPlayer();
          }
        }
      });
    }
  }

  function addBodyPadding() {
    var bar = playerEl.querySelector('.loa-bg-player__bar');
    var h = bar ? bar.offsetHeight : 52;
    document.body.style.paddingBottom = h + 'px';
  }

  function removeBodyPadding() {
    document.body.style.paddingBottom = '';
  }

  function showPlayer(track) {
    if (!playerEl || !track || !track.ytId) return;
    titleEl.textContent = track.title || '—';
    playerEl.classList.add('is-active');
    addBodyPadding();

    if (typeof YT !== 'undefined' && YT.Player) {
      createOrUpdateYT(track);
    } else {
      pendingTrack = track;
    }
  }

  function stopPlayer() {
    if (!playerEl) return;
    playerEl.classList.remove('is-active');
    removeBodyPadding();

    if (ytPlayer && typeof ytPlayer.stopVideo === 'function') {
      ytPlayer.stopVideo();
    }

    // On the sound page the hero keeps playing — only clear localStorage
    // so the bar doesn't restore on next non-sound page
    try { localStorage.removeItem(STORAGE_KEY); } catch(e) {}
  }

  function handleToggle() {
    if (!ytPlayer) return;
    if (isPaused) {
      ytPlayer.playVideo();
      setPlayingState();
    } else {
      ytPlayer.pauseVideo();
      setPausedState();
    }
  }

  // YT API calls this globally when the script is ready
  var _existingAPIReady = window.onYouTubeIframeAPIReady;
  window.onYouTubeIframeAPIReady = function() {
    if (typeof _existingAPIReady === 'function') _existingAPIReady();
    if (pendingTrack) {
      createOrUpdateYT(pendingTrack);
      pendingTrack = null;
    }
  };

  function init() {
    playerEl  = document.getElementById('loa-bg-player');
    if (!playerEl) return;

    // The #loa-bg-iframe div is the YT.Player mount point — must be a div, not an iframe
    titleEl   = document.getElementById('loa-bg-title');
    toggleBtn = document.getElementById('loa-bg-toggle');
    closeBtn  = document.getElementById('loa-bg-close');
    iconPause = toggleBtn ? toggleBtn.querySelector('.icon-pause') : null;
    iconPlay  = toggleBtn ? toggleBtn.querySelector('.icon-play')  : null;

    if (toggleBtn) toggleBtn.addEventListener('click', handleToggle);
    if (closeBtn)  closeBtn.addEventListener('click', stopPlayer);

    // Listen for event fired from the sound page bg button — show bar even on sound page
    document.addEventListener('loa:bg-play', function(e) {
      if (!e.detail) return;

      if (isSoundPage()) {
        // On the sound page the hero is already playing — just show the bar UI
        // without loading the hidden iframe (which would cause double audio)
        if (!playerEl) return;
        titleEl.textContent = e.detail.title || '—';
        playerEl.classList.add('is-active');
        addBodyPadding();
        setPlayingState();
        return;
      }

      showPlayer(e.detail);
    });

    // Load the YT IFrame API script on every page (idempotent)
    if (!document.getElementById('loa-yt-api')) {
      var tag = document.createElement('script');
      tag.id  = 'loa-yt-api';
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    }

    // Auto-restore from localStorage after navigation
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        var track = JSON.parse(stored);
        if (track && track.ytId) {
          if (isSoundPage()) {
            // On the sound page: show bar UI only — no hidden iframe needed,
            // the hero is the audio source
            titleEl.textContent = track.title || '—';
            playerEl.classList.add('is-active');
            addBodyPadding();
            setPlayingState();
          } else {
            showPlayer(track);
          }
        }
      }
    } catch(e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


/* =============================================================================
   LOA TOP-LEVEL NAV — click-to-open mega menu (disable hover)
   Prestige's theme.min.js opens the mega menu on hover via a delegated,
   capture-phase listener we can't reliably out-capture. So instead we let it
   set aria-hidden="false", then a MutationObserver immediately reverts it —
   UNLESS we opened it ourselves via click (tracked with a data flag).
   Desktop only (mega menu is hidden below 1140px).
   ============================================================================= */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 1140px)';

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  function megaMenus() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.Header__MainNav .HorizontalList__Item[aria-haspopup="true"] > .MegaMenu')
    );
  }

  /* While a panel rolls up, the header holds its solid state, and only then
     hands back to Prestige's transparent mode — so header and panel leave as
     one surface. On mouseleave Prestige closes the menu and turns the header
     transparent in the same frame, and its 0.3s fade outruns the panel.
     CLOSE_MS must match the .MegaMenu clip-path transition in header.liquid. */
  var CLOSE_MS = 600;
  var header = null;
  var closingTimer = null;
  var heldTransparent = false;

  function stripTransparent() {
    if (closingTimer && header.classList.contains('Header--transparent')) {
      header.classList.remove('Header--transparent');
      heldTransparent = true;
    }
  }

  function releaseHeader() {
    closingTimer = null;
    header.classList.remove('loa-mm-closing');
    if (!heldTransparent) return;
    heldTransparent = false;

    // Prestige's own rule: transparent only at the top of the page, and not
    // while the header is in use.
    var inUse = header.matches(':hover') ||
      header.contains(document.activeElement) ||
      header.querySelector('.MegaMenu[aria-hidden="false"]');
    if (window.pageYOffset <= 10 && !inUse) {
      header.classList.add('Header--transparent');
    }
  }

  function holdHeader() {
    if (!header) return;
    clearTimeout(closingTimer);
    closingTimer = setTimeout(releaseHeader, CLOSE_MS);
    header.classList.add('loa-mm-closing');
    stripTransparent();
  }

  function closeMenu(mm) {
    mm.dataset.loaOpen = '';
    if (mm.getAttribute('aria-hidden') !== 'true') {
      holdHeader();
      mm.setAttribute('aria-hidden', 'true');
    }
  }

  function closeAll(except) {
    megaMenus().forEach(function (mm) {
      if (mm === except) return;
      closeMenu(mm);
    });
  }

  function init() {
    var nav = document.querySelector('.Header__MainNav');
    if (!nav) return;

    header = nav.closest('.Header');
    if (header) {
      // Prestige may re-add the class mid-close (e.g. a scroll event at the
      // top of the page) — keep it off until the panel is gone.
      new MutationObserver(stripTransparent)
        .observe(header, { attributes: true, attributeFilter: ['class'] });
    }

    // Watch every mega menu. If Prestige (hover) flips aria-hidden to false
    // but we didn't mark it open via click, snap it straight back to true.
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName !== 'aria-hidden') return;
        var mm = m.target;

        // Closed by anything (Prestige closes it on mouseleave) → forget the
        // click, so hovering back over the link can't reopen it.
        if (mm.getAttribute('aria-hidden') !== 'false') {
          if (mm.dataset.loaOpen === '1') holdHeader();
          mm.dataset.loaOpen = '';
          return;
        }

        var openedByClick = mm.dataset.loaOpen === '1';
        if (!openedByClick) {
          mm.setAttribute('aria-hidden', 'true');
        }
      });
    });

    megaMenus().forEach(function (mm) {
      observer.observe(mm, { attributes: true, attributeFilter: ['aria-hidden'] });
    });

    // Click a top-level link with a mega menu → toggle it.
    nav.addEventListener('click', function (e) {
      if (!isDesktop()) return;

      // Clicks INSIDE the mega menu panel are real links — let them navigate.
      // (The panel is a descendant of the <li>, so the closest() below would
      // otherwise match and preventDefault() would swallow the link.)
      if (e.target.closest('.MegaMenu')) return;

      var item = e.target.closest('.Header__MainNav .HorizontalList__Item[aria-haspopup="true"]');
      if (!item) return;

      var mm = item.querySelector(':scope > .MegaMenu');
      if (!mm) return; // no dropdown → let the link navigate

      e.preventDefault();
      e.stopPropagation();

      var isOpen = mm.dataset.loaOpen === '1';
      closeAll(mm);
      if (isOpen) {
        closeMenu(mm);
      } else {
        mm.dataset.loaOpen = '1';
        mm.setAttribute('aria-hidden', 'false');
      }
    }, true);

    // Outside click closes.
    document.addEventListener('click', function (e) {
      if (e.target.closest('.Header__MainNav')) return;
      closeAll(null);
    });

    // Esc closes.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* =============================================================================
   LOA SIDEBAR MENU — cart icon opens the cart drawer, not the cart page
   The cart icon already has data-action="open-drawer" data-drawer-id="sidebar-cart"
   (added in sidebar-menu.liquid), so Prestige opens the cart drawer. But the menu
   drawer is still open on top, so we also close the menu when the cart is opened.
   ============================================================================= */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var cartIcon = e.target.closest('[data-loa-menu-cart]');
    if (!cartIcon) return;

    // Close the sidebar menu via its own close control so Prestige handles state.
    var menuClose = document.querySelector('[data-action="close-drawer"][data-drawer-id="sidebar-menu"]');
    if (menuClose) {
      // Defer so the cart drawer's open-drawer action fires first.
      setTimeout(function () { menuClose.click(); }, 10);
    }
  });
})();
